import React from 'react';
import { StarIcon } from 'lucide-react';
import { reviews } from '../../data/content';
import { images } from '../../data/images';
function Stars() {
  return <span className="flex" aria-label="5 van 5 sterren" data-id="element-228" data-mp="2frvfspfitolw">
      {[0, 1, 2, 3, 4].map(i => <StarIcon key={i} className="h-4 w-4 fill-ink text-ink" aria-hidden="true" data-id="element-229" data-mp="2kmrfmbr01g9k" />)}
    </span>;
}
export function Reviews() {
  const [featured, ...rest] = reviews;
  return <section className="bg-canvas-deep" data-id="element-230" data-mp="1svbjnr3jyh6o">
      <div className="mx-auto max-w-[1440px] px-4 py-24 sm:px-6 lg:px-10 lg:py-32" data-id="element-231" data-mp="1wuu9906bjgfu">
        <div className="grid gap-10 lg:grid-cols-[1fr_1.1fr] lg:gap-16" data-id="element-232" data-mp="21u6tdd5t29eq">
          <img src={images.family} alt="Stel in hun keuken dat samen de Stroomkluis app bekijkt" className="aspect-[4/3] w-full rounded-3xl object-cover lg:aspect-auto lg:h-full" data-id="element-233" data-mp="21svr5hs0d9pq" />
          <div className="flex flex-col" data-id="element-234" data-mp="3i8gfe0mkrm2e">
            <Stars data-id="element-235" data-mp="3i75dk6cowodx" />
            <blockquote className="mt-6" data-id="element-236" data-mp="3i6lv8oj4nxzd">
              <p className="text-2xl font-medium leading-snug tracking-tight text-ink sm:text-[32px] sm:leading-[1.2]" data-id="element-237" data-mp="v6lehu2lmxc9">
                “{featured.text}”
              </p>
              <footer className="mt-6 text-[15px] text-ink-muted" data-id="element-238" data-mp="r3fbqwep3oaj">
                <span className="font-medium text-ink" data-id="element-239" data-mp="m4vrr1jnwmkt">{featured.name}</span> · {featured.place} · {featured.system}
              </footer>
            </blockquote>

            <div className="mt-auto grid gap-8 border-t border-line pt-8 sm:grid-cols-2" data-id="element-240" data-mp="c8iwhz8gy0ny">
              {rest.map(r => <blockquote key={r.name} className="flex flex-col" data-id="element-241" data-mp="7ghbnox8j1mb">
                  <p className="text-[16px] leading-relaxed text-ink-soft" data-id="element-242" data-mp="3f5v08wc9qq9">“{r.text}”</p>
                  <footer className="mt-auto pt-4 text-sm text-ink-muted" data-id="element-243" data-mp="3um8m70c6fx0h">
                    <span className="font-medium text-ink" data-id="element-244" data-mp="3ujvx83804mdx">{r.name}</span> · {r.place}
                    <div data-id="element-245" data-mp="3pm4270c28k5i">{r.system}</div>
                  </footer>
                </blockquote>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}